export const LANG_LOCAL_STORAGE_KEY = 'language'
export const LANG_BG = 'bg'
export const LANG_EN = 'en'